"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Card = _interopRequireDefault(require("@/ui/components/Card"));
var _InputSearch = _interopRequireDefault(require("@/ui/components/InputSearch"));
var _moment = _interopRequireDefault(require("moment"));
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _filterDate = _interopRequireDefault(require("@/ui/components/filterDate"));
var _ModalOccurrence = _interopRequireDefault(require("../components/ModalOccurrence"));
var _vuex = require("vuex");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default2 = exports.default = {
  name: 'OccureencesList',
  components: {
    Card: _Card.default,
    InputSearch: _InputSearch.default,
    ModalOccurrence: _ModalOccurrence.default,
    filterDate: _filterDate.default,
    Page: _Page.default
  },
  props: {
    plot: {
      type: Object,
      default: undefined
    },
    managePlot: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      search: '',
      showModal: false,
      services: [],
      notReviewed: [],
      inReview: [],
      analyzeds: [],
      occurrenceDateStart: (0, _moment.default)().weekday(1).toDate(),
      occurrenceDateEnd: (0, _moment.default)().weekday(7).toDate(),
      occurrenceSelected: null,
      allOccurrencesModel: []
    };
  },
  watch: {
    occurrenceDateStart: function occurrenceDateStart(newVal, oldVal) {
      var today = (0, _moment.default)(oldVal).format('YYYY/MM/DD');
      var newDate = (0, _moment.default)(newVal).format('YYYY/MM/DD');
      if (today !== newDate) {
        this.prepareData();
      }
    },
    occurrenceDateEnd: function occurrenceDateEnd(newVal, oldVal) {
      var today = (0, _moment.default)(oldVal).format('YYYY/MM/DD');
      var newDate = (0, _moment.default)(newVal).format('YYYY/MM/DD');
      if (today !== newDate) {
        this.prepareData();
      }
    }
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)({
    allOcurrences: 'allOcurrences',
    menuItemsOccurrences: 'menuItemsOccurrences'
  })),
  mounted: function mounted() {
    _moment.default.locale('pt-BR');
    this.prepareData();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getOcurrencesRest', 'getTypeOcurrencesRest', 'getlistFetchOcurrencesRatings', 'setLoading'])), {}, {
    updateDateFilter: function updateDateFilter(options) {
      if (options.type === 'from') this.occurrenceDateStart = options.data;
      if (options.type === 'to') this.occurrenceDateEnd = options.data;
    },
    arrayFilter: function arrayFilter(arrayItems) {
      var self = this;
      var array = arrayItems || [];
      if (!array.length) return [];
      return array.filter(function (item) {
        var criticality = self.$options.filters.convetCriticity(item.criticality);
        return item.description && item.description.toLowerCase().indexOf(self.search.toLowerCase()) > -1 || criticality && criticality.toLowerCase().indexOf(self.search.toLowerCase()) > -1 || item.type && item.type.name && item.type.name.toLowerCase().indexOf(self.search.toLowerCase()) > -1 || (item.user && item.user.firstName.toLowerCase().indexOf(self.search.toLowerCase())) > -1 || item.user.lastName.toLowerCase().indexOf(self.search.toLowerCase()) > -1;
      });
    },
    prepareData: function () {
      var _prepareData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var self, payload, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              self = this;
              self.setLoading(true);
              self.notReviewed = [];
              self.inReview = [];
              self.analyzeds = [];
              payload = {
                params: {
                  from: (0, _moment.default)(this.occurrenceDateStart).format('YYYY/MM/DD'),
                  to: (0, _moment.default)(this.occurrenceDateEnd).format('YYYY/MM/DD')
                }
              };
              _context.p = 1;
              _context.n = 2;
              return self.getOcurrencesRest(payload);
            case 2:
              self.allOcurrences.forEach(function (occurrence) {
                switch (occurrence.status.toUpperCase()) {
                  case 'NOT_REVIEWED':
                    self.notReviewed.push(occurrence);
                    break;
                  case 'IN_REVIEW':
                    self.inReview.push(occurrence);
                    break;
                  case 'ANALYZED':
                    self.analyzeds.push(occurrence);
                    break;
                }
              });
              self.setLoading(false);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              self.setLoading(false);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function prepareData() {
        return _prepareData.apply(this, arguments);
      }
      return prepareData;
    }(),
    formatViewDate: function formatViewDate(date) {
      var check = (0, _moment.default)(date);
      var dayName = check.format('dddd');
      var day = check.format('DD');
      var month = check.format('MMMM');
      return dayName + ' , ' + day + ' de ' + month;
    },
    openModal: function () {
      var _openModal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(item) {
        var self, response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              self = this;
              self.setLoading(true);
              _context2.p = 1;
              _context2.n = 2;
              return this.getOcurrencesRest(item);
            case 2:
              response = _context2.v;
              this.openModalOccurrence(response);
              self.setLoading(false);
              this.getOccurrencesModel(response.subPlot);
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              self.setLoading(false);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function openModal(_x) {
        return _openModal.apply(this, arguments);
      }
      return openModal;
    }(),
    nameItem: function nameItem(item) {
      var oc = item.type ? item.type : null;
      if (oc) return oc.name;
      return 'Sem classificação';
    },
    openModalOccurrence: function openModalOccurrence(service) {
      this.occurrenceSelected = service;
      this.showModal = !this.showModal;
    },
    closedModalOccurrence: function closedModalOccurrence(item) {
      this.showModal = false;
      if (item && item === 'reload') {
        this.prepareData();
      }
    },
    getOccurrencesModel: function () {
      var _getOccurrencesModel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(subplot) {
        var productID, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              productID = subplot ? subplot.productId : '';
              _context3.n = 1;
              return this.getlistFetchOcurrencesRatings(productID);
            case 1:
              data = _context3.v;
              if (data) this.allOccurrencesModel = data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getOccurrencesModel(_x2) {
        return _getOccurrencesModel.apply(this, arguments);
      }
      return getOccurrencesModel;
    }()
  })
};